import React from 'react';
import { clsx, multiply, createUseStyles } from '@pushpay/styles';
import Skeleton from '.';
const useStyles = createUseStyles(theme => ({
  root: {
    display: 'flex',
    border: `1px solid ${theme.colors['color-border-surface']}`
  },
  column: {
    margin: 0,
    padding: 0
  },
  row: {
    padding: `0.5em 0 0.5em ${multiply(theme.SPACING.GUTTER, 2)}`,
    width: 'auto',
    '&+&': {
      margin: 0,
      borderTop: `1px solid ${theme.colors['color-border-surface']}`
    }
  },
  withHeader: {
    '&:first-of-type': {
      backgroundColor: theme.colors['palette-grey-light-300']
    }
  },
  withAvatarHeader: {
    '&:first-of-type': {
      paddingLeft: '3.5em'
    }
  },
  lastColumn: {
    padding: `0.5em ${multiply(theme.SPACING.GUTTER, 2)}`
  }
}));
export const SkeletonTable = props => {
  const {
    rows,
    columns,
    header = true,
    avatar,
    classes: classesProp,
    className: classNameProp,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, classNameProp);
  const columnDefinitions = typeof columns === 'number' ? Array(columns).fill(1) : columns;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: className
  }, rest), columnDefinitions.map((columnSpan, index) => {
    const key = `column-${index}`;
    const isAvatarColumn = avatar && index === 0;
    const rowDefinitions = Array(rows + (header ? 1 : 0)).fill({
      width: 100,
      avatar: isAvatarColumn
    });

    if (isAvatarColumn) {
      // Hide avatar in the header
      rowDefinitions[0] = {
        width: 0
      };
    }

    return /*#__PURE__*/React.createElement(Skeleton, {
      key: key,
      style: {
        flex: columnSpan
      },
      classes: {
        root: classes.column,
        row: clsx(classes.row, index === columnDefinitions.length - 1 && classes.lastColumn, header && classes.withHeader, header && isAvatarColumn && classes.withAvatarHeader)
      },
      rows: rowDefinitions,
      "data-pp-at-target": key
    });
  }));
};